import { alertMessages } from "../components/Common/CommonErrorMsg/alertMsg";
import { GET_COMPANY_FROM_URL, getBasicAuthFromSetting, loginSystemSetting } from "../components/Common/CommonFunction";
import { customAlert } from "../CustomAlert/ConfirmDialog";


import { axiosApi } from "./axios_Config"

const isBlockedEnv = () => {
  const setting = loginSystemSetting();
  return setting.BlockOutgoingAPIsinTestEnvironment;
};


const getSkipApis = () => {
  try {
    const setting = loginSystemSetting();
    const raw = setting?.SkipApis;

    const list = raw
      ?.split(",")
      .map(x => x.trim().toLowerCase()) || [];

    return list;
  } catch (err) {
    console.error("❌ [SkipApis] Error:", err);
    return [];
  }
};

const shouldSkip = (url) => {
  const settingValue = isBlockedEnv();
  if (!settingValue) return false;

  const [urlPart = "", companyPart = ""] = settingValue.split("|");

  const allowedBaseUrls = urlPart
    .split(",")
    .map(x => x.trim())
    .filter(Boolean);

  const allowedCompanies = companyPart
    .split(",")
    .map(x => x.trim().toUpperCase())
    .filter(Boolean);

  const company = (GET_COMPANY_FROM_URL());

  const blockApis = getSkipApis(); // 🔁 treat this as BLOCK list

  const isBlockedApi = blockApis.some(api =>
    url.toLowerCase().includes(api)
  );

  // ✅ hostname/origin check (IMPORTANT FIX)
  const currentOrigin = window.location.origin;

  const isUrlMatch = allowedBaseUrls.some(base =>
    currentOrigin.includes(base)
  );

  const isCompanyMatch = allowedCompanies.includes(company);

  // ✅ CASE 1: FULL MATCH → allow everything
  if (isCompanyMatch || isUrlMatch) {
    return false;
  }

  // ✅ CASE 2: NOT MATCHED → block ONLY listed APIs
  if (isBlockedApi) {
    return true;
  }

  // ✅ CASE 3: NOT MATCHED but API not in block list → allow
  return false;
};

const shouldBlockExternalUrl = (url) => {
  const settingValue = isBlockedEnv();

  if (!settingValue) return false;

  const [urlPart = ""] = settingValue.split("|");

  const allowedBaseUrls = urlPart
    .split(",")
    .map(x => x.trim().replace(/^"|"$/g, ""));

  const currentOrigin = window.location.origin;

  const isOriginAllowed = allowedBaseUrls.some(base =>
    currentOrigin.includes(base)
  );

  const isUrlAllowed = allowedBaseUrls.some(base =>
    url.startsWith(base)
  );

  // ✅ allow only if BOTH origin or url match
  return !(isOriginAllowed || isUrlAllowed);
};

// ✅ Centralized blocked-API handler: logs + shows alert + rejects
const blockApiWithAlert = (url) => {
  console.log(`API Blocked ${url}`);
  customAlert({
    Type: 4,
    Message: alertMessages.apiBlockedInTestEnv,
  });
  return Promise.reject("Blocked");
};


export function get(url, param) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .get(url, param)
    .then((response) => {
      return response.data;
    })

}

export function post(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .post(url, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
}

export function put(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .put(url, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {

      return response.data;
    })

}

export function del(url) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .delete(url)
    .then((response) => {
      return response.data;
    })

}


export function postWithoutToken(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .post(url, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: null,
      },
    })
    .then((response) => {
      return response.data;
    })
}

export async function postRefreshToken(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .post(url, body, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
}

export function getWithotMsg(url) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  // CommonConsole(`${url} :get api call `);
  return axiosApi
    .get(url)
    .then((response) => {
      return response.data;
    });

}

export function postMethodExcel(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  // CommonConsole(`${url} :post api call `);
  return axiosApi
    .post(url, body, {
      responseType: "arraybuffer",
    })
    .then((response) => {
      return response.data;
    });
}



export function delwithPostBody(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }

  return axiosApi
    .delete(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: body
    })
    .then((response) => {
      return response.data;
    });
}


export function postForFormData(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }

  return axiosApi
    .post(url, body, {
      headers: {
        Accept: "application/json",
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      return response.data;
    })

}


export function putForFormData(url, body) {
  if (shouldSkip(url)) {
    return blockApiWithAlert(url);
  }
  return axiosApi
    .put(url, body, {
      headers: {
        Accept: "application/json",
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      return response.data;
    })

}


export function postForFormData_SecondServer(body) {

  let systemSetting;
  try {
    systemSetting = loginSystemSetting();
  } catch (err) {
    return Promise.reject("SystemSetting() failed");
  }

  const setting = systemSetting.ORDER_SEND_CBM_to_CSS_URLDetails;

  const [url, username, password] = setting
    .split(",")
    .map(x => x.trim().replace(/^"|"$/g, ""));

  if (shouldBlockExternalUrl(url)) {
    customAlert({ Type: 4, Message: alertMessages.apiBlockedInTestEnv });
    return Promise.reject("Blocked");
  }

  return axiosApi
    .post(url, body, {
      auth: { username, password },
      headers: { Accept: "application/json" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("❌ Error while sending data to 8002 server:", error.response?.data || error);
      throw error;
    });
}


export function postForFormData_fristServer(body) {
  let systemSetting;
  try {
    systemSetting = loginSystemSetting();
  } catch (err) {
    return Promise.reject("SystemSetting() failed");
  }

  const setting = systemSetting.INVOICE_SEND_CBM_to_CSS_URLDetail;

  const [url, username, password] = setting
    .split(",")
    .map(x => x.trim().replace(/^"|"$/g, ""));

  if (shouldBlockExternalUrl(url)) {
    customAlert({ Type: 4, Message: alertMessages.apiBlockedInTestEnv });
    return Promise.reject("Blocked");
  }

  return axiosApi
    .post(url, body, {
      auth: { username, password },
      headers: { Accept: "application/json" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("❌ Error while sending data to 8002 server:", error.response?.data || error);
      throw error;
    });
}


export function FetchItemOnItemSAPCode(editId) {

  let systemSetting;
  try {
    systemSetting = loginSystemSetting();
  } catch (err) {
    return Promise.reject("SystemSetting() failed");
  }

  const setting = systemSetting.FetchItemOnItemSAPCode;

  const [url, username, password] = setting
    .split(",")
    .map(x => x.trim().replace(/^"|"$/g, ""));

  const finalUrl = `${url}/${`SapItemCode=${editId}`}`;

  const token = btoa(`${username}:${password}`);

  return axiosApi
    .get(finalUrl, {
      headers: {
        Authorization: `Basic ${token}`,
        Accept: "application/json",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error(
        "❌ Error while fetching item from external server:",
        error.response?.data || error
      );
      throw error;
    });
}



export function getWithBasicAuth(url) {
  const { username, password } = getBasicAuthFromSetting();

  return axiosApi
    .get(url, {
      auth: {
        username,
        password,
      },
      headers: {
        Accept: "application/json",
      },
    })
    .then((response) => response.data)
};



export function FetchPartyOnPartySAPCode(editId) {

  let systemSetting;
  try {
    systemSetting = loginSystemSetting();
  } catch (err) {
    return Promise.reject("SystemSetting() failed");
  }

  const setting = systemSetting.FetchPartyOnPartySAPCode;

  const [url, username, password] = setting
    .split(",")
    .map(x => x.trim().replace(/^"|"$/g, ""));

  const finalUrl = `${url}/${`SAPPartyCode=${editId}`}`;

  const token = btoa(`${username}:${password}`);

  return axiosApi
    .get(finalUrl, {
      headers: {
        Authorization: `Basic ${token}`,
        Accept: "application/json",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error(
        "❌ Error while fetching item from external server:",
        error.response?.data || error
      );
      throw error;
    });
}